const api = `https://${location.hostname}/cgi-bin/cupe-app-api/api.py`;
var permissions = {};
let maintenance = "";
export default {
    authenticate(){
        const that = this;
        // Return new promise
        return new Promise(function (resolve, reject) {
            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if(json.hasOwnProperty("maintenance")){
                        if(json.maintenance.hasOwnProperty("group")){
                            maintenance = json.maintenance.group;
                        }else {
                            maintenance = "none";
                        }
                    }else {
                        maintenance = "none";
                    }
                    
                    // Parse JSON response and check for authentication success
                    if (json.result.match(/^OK/i)) {
                        // Store user data in session storage
                        if(json.department != "student"){
                            let user = {
                                "department": json.department,
                                "commonname": json.commonname,
                                "username" : json.username,
                                "admin": json.admin
                            };
                            sessionStorage.setItem('user', JSON.stringify(user));
                            
                            if(json.permissions.hasOwnProperty("result")){
                                if(json.permissions.result.match(/^OK/i)){
                                    permissions = json.permissions.data[0];
                                }
                            }else if(json.permissions.hasOwnProperty("rootgroup")){
                                permissions = json.permissions;
                            }
                            resolve(true);
                        }else {
                            that.destroy_session();
                            reject(false); 
                        }
                        
                    }else {
                        if(that.get_user()["department"] == "applicant"){
                            resolve(true);
                        }else {
                            // Authentication was unsuccessful
                            that.destroy_session();
                            reject(false);
                        }
                    }
                })
                .catch(function () {
                    // API call was unsuccessful
                    that.destroy_session();
                    reject(false);
                })
        })
    },
    create_session(department, commonname, username) {

        let user = {
            "department": department,
            "commonname": commonname,
            "username" : username
        };

        // Create user session storage
        try {
            sessionStorage.setItem('user', JSON.stringify(user));
        } catch (error) {
            console.log(error);
        }
    },
    destroy_session() {
        // Destroy session storage
        sessionStorage.clear();
    },
    get_user() {
        // Return user object
        let user = sessionStorage.getItem('user');
        if(user != null){
            return JSON.parse(sessionStorage.getItem('user'));
        }else {
            return {}
        }
    },
    get_impersonated_user(){
        //Used when the Admin tries to access on behalf of an applicant
        //Session name cupeapp_aaa - admin as applicant
        return JSON.parse(sessionStorage.getItem('cupeapp_aaa'));
    },
    is_applicant(){
        let user = this.get_user();

        if(user.hasOwnProperty("department") && user.department.match(/^applicant/i)){
            return true
        }else {
            return false
        }
    },
    is_AdminMember(){
        let user = this.get_user();

        if(user["admin"] == 1){
            return true
        }else {
            return false
        }
    },
    is_ITS(){
        let user = this.get_user();

        if(user["admin"] == 1 && user.department.match(/Information Technology Services/i) && this.get_permissions().hasOwnProperty("rootgroup")){
            return true
        }

        return false
    },
    is_account_active(){
        let user = this.get_user();

        if(user.status != null && user.status.match(/^true/i)){
            return true
        }

        return false
    },
    get_permissions(){
        return permissions
    },
    get_maintenance(){
        return maintenance
    }
}